import { PageHeader } from '../../components/ui/index';
import MissionsList from '../../components/missions/MissionsList';

export default function MyMissionsPage() {
  return (
    <div className="fade-in">
      <PageHeader title="ماموریت‌های من" />
      <MissionsList />
    </div>
  );
}
